export const stringToArray = (stringData) => {
	if (!stringData) return []
	return stringData.split("");
}